// extracted by mini-css-extract-plugin
export var animationContainer = "_e5-0";
export var asteriskIcon = "_e5-8";
export var conversationLeftSection = "_e5-4";
export var conversationListItem = "_e5-3";
export var conversationMiddleSection = "_e5-5";
export var conversationRightSection = "_e5-6";
export var detailsContent = "_e5-1";
export var listContainer = "_e5-7";
export var modalContent = "_e5-2";